export default __webpack_public_path__ + "static/img4-2927a1042dd098ed9b1c1bb0cb71f1e6.png";